<div>
    <app-header></app-header>
</div>

<div class="container-fluid mt-3" *ngIf="stoken">
    <div class="row">
        <div class="col-md-6">
            <div class="productimgBox">
                <img *ngIf="images" [src]="selectedImage?.url" [alt]="productData?.title || 'Product'"
                    class="product-main-img" />
                <div class="d-flex  custom-sub-main" *ngIf="images">
                    <img *ngFor="let img of images" [src]="img.url" [alt]="productData?.title || 'Product'"
                        (click)="onImageClick(img)" class="product-sub-main-img" />
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="productDetail pe-3">
                <!-- <div class="catname-head">
                    <span class="catname"> Raw Material</span>
                </div> -->
                <!-- {{productData.productDetails.interestShown | json}} -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <h2 class="producttitle">{{ productData?.Category3?.title }} </h2>
                    </div>
                    <!-- <div class="col-md-2 d-flow p-2">
                        <img src="assets/images/new_img/Star.svg"><span class="rating"> (4.2)</span>
                    </div> -->
                </div>
                <p class="mt-2 mb-0">Offered by: <a style="cursor: pointer;" (click)="navigatOnProfile()"
                        class="text-g">{{productData?.Auth?.UserAuths[0]?.company_name || 'Null'}}
                        <span *ngIf="stateDetails">,{{
                            productData.stateDetails?.name }},{{
                            productData.cityDetails?.city }}</span>
                    </a>
                    <span class="successbox"><img src="assets/images/new_img/success.svg" class="" alt="">Trusted
                        Partner </span>
                </p>
                <p class="mt-2 mb-0"> <span>Available Stock:</span> <span
                        class="text-g">{{productData?.number_units_available || 'N/A'}}</span></p>
                <p class="mt-2 mb-0"><span>Price:</span><span class="text-g">{{productData?.price || 'Ask for
                        Price'}}</span><span *ngIf="productData?.punit" class="text-g">/{{productData?.punit ||
                        ''}}</span></p>
                <p class="mt-2 mb-0"> <span>GST Number:</span><span class="text-g">{{
                        productData?.Auth?.UserAuths[0]?.gst_no || 'N/A'
                        }}</span> </p>
                <div class="row mt-3 mb-3">
                    <div class="qty-div col-md-3 ">
                        <input type="text" placeholder="Qty (Enter Here)" class="form-control qty-text">
                    </div>
                </div>
                <!-- <input type="text" placeholder="Qty (Enter Here)" class="form-control"> -->
                <div class="row mb-2">
                    <div class="col-md-3 d-flex py-1 align-items-center">
                        <input type="checkbox"><span class="ms-2 loan-text"> Loan required</span>
                    </div>
                </div>

                <div class="productBtn d-flex justify-content-between mt-2 mb-3 row">
                    <div class="col-md-6">
                        <button (click)="toggleWishlist()" class="productbtnborder">
                            <img [src]="isInWishlist ? 'assets/images/new_img/heartfull.png' : 'assets/images/new_img/heart.svg'"
                                alt="">
                            <span class="ms-2">{{ isInWishlist == true ? 'Remove from Wishlist' : 'Add to Wishlist'
                                }}</span>
                        </button>
                    </div>
                    <div class="col-md-6 ">
                        <button (click)="toggleGetQuote()" class="productDetailbg">
                            <span>
                                Get a Quote
                            </span>
                            <!-- <span>{{ isGetQuote ? 'Remove from Quote' : 'Get a Quote' }}</span> -->
                        </button>
                    </div>
                </div>
                <div class="divider mt-3 mb-4"> </div>
                <div class="tags d-flex row">
                    <div class="col-md-12 high-text">
                        <h3 class="pheadsub"> Highlights</h3>
                    </div>
                    <!-- {{productData | json}} -->
                    <div class="data col-md-6" *ngIf="productData?.material_grade">
                        <div class="custom-card me-2 mb-1">
                            <div class="center-div">
                                <span class="m-0 type ">Material Grade</span><br>
                                <span id="below" class="m-0 value">{{productData?.material_grade || 'N/A' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="data col-md-6" *ngIf="productData?.unit_measure">
                        <div class="custom-card mb-1">
                            <div class="center-div">
                                <span class="m-0 type">Unit of Measure</span><br>
                                <span id="below" class="m-0 value">{{productData?.unit_measure || 'N/A' }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="data col-md-6">
                        <div class="custom-card me-2">
                            <div class="center-div">
                                <span class="m-0 type">Location</span><br>
                                <span id="below" class="m-0 value">{{productData?.location }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="data col-md-6" *ngIf="productData?.ownership_type">
                        <div class="custom-card">
                            <div class="center-div">
                                <span class="m-0 type">Type Of property</span><br>
                                <span id="below" class="m-0 value">{{productData?.ownership_type }}</span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <!-- *ngIf="productData?.offer_applicable == 'yes'" -->
                <div class="divider my-4"> </div>

                <div class="productOffers mt-3" *ngIf="productData?.offer_details">
                    <div class="high-text">
                        <p class="pheadsub"> Offers</p>
                    </div>
                    <h5><img src="assets/images/new_img/offertick.svg" class="" alt="" /> {{productData?.offer_details}}
                        <!-- {{productData?.offer_details}} -->
                    </h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 overview-h pe-5 ps-5">
            <h4 class="text-center mt-4 o-heading"> Overview</h4>
            <div class="p-2">
                <h5 class="deschead" *ngIf="productData?.description"> Product Description</h5>
                <ul class="descdesc" *ngIf="productData?.description">
                    <li>{{productData?.description}}</li>


                </ul>
                <h5 class="deschead" *ngIf="productData?.highlights"> Specifications</h5>
                <p class="deschead" *ngIf="productData?.highlights">{{productData?.highlights}}</p>

            </div>
        </div>
        <div class="col-md-12 overview-h pe-5 ps-5">
            <ul class="productinfo p-0">
                <li *ngIf="productData?.Industry?.industry_name"> <span> Offering</span> <span>
                        {{productData?.Industry?.industry_name || 'N/A'}}</span> </li>
                <li *ngIf="productData?.Category1?.title"> <span> Industry</span> <span> {{productData?.Category1?.title
                        || 'N/A'}}</span> </li>
                <li *ngIf="productData?.Category2?.title"> <span> Category</span> <span> {{productData?.Category2?.title
                        || 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.Category3?.title"> <span> Sub Category</span> <span>
                        {{productData?.Category3?.title || 'N/A'}}</span>
                </li>
                <li *ngIf="productData?.packaging_details"> <span> Packaging</span> <span>
                        {{productData?.packaging_details || 'N/A'}}</span> </li>
                <li *ngIf="productData?.warranty_period"> <span> Warranty Period(month)</span> <span> {{productData?.warranty_period
                        || 'N/A'}}</span> </li>
                <li *ngIf="productData?.shipping_terms"> <span> Logistics</span> <span> {{productData?.shipping_terms ||
                        'N/A'}}</span> </li>
                <li *ngIf="productData?.AMC !='null'"> <span> Annual Maintenance Contract (AMC)</span> <span>
                        {{productData?.AMC
                        || 'N/A'}}</span> </li>
                <li *ngIf="productData?.SLA !='null'"> <span> Service Level Agreement (SLA)</span> <span>
                        {{productData?.SLA ||
                        'N/A'}}</span> </li>
            </ul>
        </div>
    </div>
</div>

<div class="container-fluid mt-5 px-3" *ngIf="stoken">
    <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="moreFromSeller?.length !== 0">
        <div class="align-items-center row">
            <span class="mb-0 title-pp text-center mb-4">More from the Seller</span>

            <!-- Loop through moreFromSeller array -->
            <div class="col-md-3 mb-4" *ngFor="let prod of moreFromSeller">
                <!-- New box with styling -->
                <div class="normalbox">
                    <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
                        <span class="newtick">Top Seller</span>
                        <div class="normalboximg" *ngIf="prod">
                            <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url"
                                class="img-fluid normalimg" alt="{{ prod.title }}" />
                        </div>
                        <div class="normalboxDetail">
                            <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div> -->
                            <h5>{{ prod.Category3?.title }}</h5>
                            <p class="location d-flex align-items-center">
                                <span *ngIf="prod.cityDetails?.city"><img src="assets/images/locations.svg"
                                        class="img-fluid me-2" alt="location"></span>
                                <span *ngIf="prod.cityDetails?.city">{{
                                    prod.cityDetails?.city }},{{
                                    prod.stateDetails?.name }}</span>
                            </p>
                            <div class="price">Price <span>₹{{ prod?.price }}</span><span
                                    *ngIf="prod?.punit">/{{prod?.punit ||
                                    ''}}</span></div>
                            <div class="ContactSeller mt-2">
                                <a href=""> Contact the Seller</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweall">
                <button class="btn viewall" (click)="viewAllProductsFromSeller('moreFromSeller')">View All</button>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweless">
                <button class="btn viewall" (click)="viewLessProductsFromSeller('lessFromSeller')">View Less</button>
            </div>

        </div>
    </div>

</div>
<div class="container-fluid mt-3 px-4" *ngIf="stoken">
    <div class="industry bgcolorss mt-4 pt-4 pb-4 px-4" *ngIf="relatedProducts?.length !== 0">
        <div class="align-items-center row">
            <span class="mb-0 title-pp text-center mb-4">Related Products</span>
            <div class="col-md-3 mb-4" *ngFor="let prod of relatedProducts">
                <div class="normalbox">
                    <div (click)="viewSingleProduct(prod.id, prod?.Industry?.industry_name)">
                        <span class="newtick">Top Seller</span>
                        <div class="normalboximg" *ngIf="prod">
                            <img *ngIf="prod.Media && prod.Media.length > 0" [src]="prod.Media[0]?.url"
                                class="img-fluid normalimg" alt="{{ prod.title }}" />
                        </div>
                        <div class="normalboxDetail">
                            <!-- <div class="catServices">{{ prod?.Industry?.industry_name }}</div> -->
                            <h5>{{ prod.Category3?.title }} </h5>
                            <p class="location d-flex align-items-center">
                                <span *ngIf="prod.cityDetails?.city"><img src="assets/images/locations.svg"
                                        class="img-fluid me-2" alt="location"></span>
                                <span *ngIf="prod.cityDetails?.city">{{
                                    prod.cityDetails?.city }},{{
                                    prod.stateDetails?.name }}</span>
                                <!-- <span> {{ prod.location }}</span> -->
                            </p>
                            <div class="price">Price <span>₹{{ prod?.price }}</span><span
                                    *ngIf="prod?.punit">/{{prod?.punit ||
                                    ''}}</span></div>
                            <div class="ContactSeller mt-2">
                                <a href=""> Contact the Seller</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viweallrel">
                <button class="btn viewall" (click)="viewAllProductsFromRelated('relatedProducts')">View All</button>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="viwelessrel">
                <button class="btn viewall" (click)="viewLessProductsFromRelated('lessrelatedProducts')">View
                    Less</button>
            </div>
        </div>
    </div>
</div>


<div>
    <app-footer></app-footer>
</div>